import { defineComponent, computed } from "vue";
import useRoomInfo from "../RoomHeader/RoomInfo/useRoomInfoHooks.mjs";
import copyIcon from "../common/icons/CopyIcon.vue.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import { isWeChat, isMobile } from "../../utils/environment.mjs";
import { useI18n } from "../../locales/index.mjs";
import { getUrlWithRoomId } from "../../utils/utils.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "InvitePanel",
  props: {
    scheduleInviteList: null,
    shareLinkData: null
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const { onCopy } = useRoomInfo();
    const scheduleInviteList = computed(() => {
      const { roomId, password } = (props == null ? void 0 : props.shareLinkData) || {};
      if (!roomId) return props.scheduleInviteList;
      return [
        {
          title: `${t("Room ID")}`,
          content: roomId,
          isShowCopyIcon: true,
          isVisible: true
        },
        {
          title: `${t("Room Password")}`,
          content: password,
          isShowCopyIcon: true,
          isVisible: !!password
        },
        {
          title: `${t("Room Link")}`,
          content: getUrlWithRoomId(roomId),
          isShowCopyIcon: true,
          isVisible: !isWeChat
        }
      ];
    });
    return { __sfc: true, t, props, onCopy, scheduleInviteList, copyIcon, SvgIcon, isMobile };
  }
});
export {
  _sfc_main as default
};
